import { render, staticRenderFns } from "./BoxServizi.vue?vue&type=template&id=178711f7"
import script from "./BoxServizi.vue?vue&type=script&lang=js"
export * from "./BoxServizi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports